<template>
	<div class="modal-backdrop" v-if="value">
		<div class="modal" tabindex="-1" role="dialog">
            <div class="modal-behind" @click="close"></div>
			<div :class="`modal-dialog${larger ? ' larger' : ''}`" role="document">
				<div class="modal-content" :class="{ loading }">
					<div class="modal-header" v-if="!hideHeader">
                        <img :src="$imageUrl('close.svg')" width="25" @click="close">
					</div>
					<div class="modal-body">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Button from "./Button";

	export default {
		name: "Modal",
		components: {
			Button
		},
		props: [
			"value",
			"title",
            "loading",
            "hideHeader",
            "larger",
		],
		methods: {
			close() {
			    if (this.loading) return;

				this.$emit("input", false);
				this.$emit("close");
			}
		}
	}
</script>
